// extracted by mini-css-extract-plugin
export var colorSquare = "_qt-0";
export var danger = "_qt-5";
export var lightPink = "_qt-8";
export var neutralBlue = "_qt-7";
export var neutralYellow = "_qt-6";
export var normal = "_qt-1";
export var primary = "_qt-2";
export var primaryLight = "_qt-3";
export var solidBlack = "_qt-g";
export var solidGreen = "_qt-b";
export var solidLightBlue = "_qt-d";
export var solidNavy = "_qt-c";
export var solidOrange = "_qt-f";
export var solidPink = "_qt-e";
export var solidRed = "_qt-9";
export var solidYellow = "_qt-a";
export var success = "_qt-4";